import api from '../infra/api'
import apiCallHandler from './apiCallHandler'

export const postCreateUser = (payload) => apiCallHandler(() => api.post('resale-bff/users/create/', payload))

export const putEditUser = (payload) => apiCallHandler(() => api.put('resale-bff/users/edit/', payload))
